import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CompanyEnums } from "models/enums";
import { OwnersWidgetSwitchProps } from "models/propTypes/holdingRegisterPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ToggleButtonGroup } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const OwnersViewTypeToggle: React.FC<OwnersWidgetSwitchProps> = (props) => {
  const initialSelection: CompanyEnums.OwnersViewType = CompanyEnums.OwnersViewType.Shareholder;

  const { onSwitchTypeChanged } = props;

  return (
    <Grid item>
      <ToggleButtonGroup
        buttons={[
          {
            buttonKey: CompanyEnums.OwnersViewType.Shareholder,
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.Shareholders),
            onClick: onSwitchTypeChanged.bind(null, CompanyEnums.OwnersViewType.Shareholder),
          },
          {
            buttonKey: CompanyEnums.OwnersViewType.OwnershipStructure,
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.OwnershipStructure),
            onClick: onSwitchTypeChanged.bind(null, CompanyEnums.OwnersViewType.OwnershipStructure),
          },
        ]}
        initialSelectionKey={initialSelection}
      />
    </Grid>
  );
};

export default OwnersViewTypeToggle;
